// @flow
import styled from 'styled-components';
import { colors } from '../../shared/styles';

const StyledForm = styled.form`
    flex-grow: 1;
    position: relative;

    & .scroll-area {
        height: calc(100% - 62px);
    }

    & .flex {
        display: flex;
    }

    & .noflex {
        display: block;
    }

    & .col {
        flex: 1;
    }

    & .maxWidth {
        max-width: 60%;
    }

    & .sticky-footer {
        box-sizing: border-box;
        position: absolute;
        bottom: 0;
        width: 100%;
        padding: 10px;
        overflow: hidden;
        text-align: right;
        background: #edf1f2;
        border-top: solid 1px ${colors.offWhite};
    }

    & h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        padding: 20px 20px 10px 20px;
        margin: 0;
        font-weight: lighter;
    }

    & .hidden {
        display: none;
        visibility: hidden;
    }

    table a {
        color: ${colors.grey.default};
    }

    .video-form {
        color: ${colors.grey.default};
        padding: 10px 20px;
        text-align: center;

        & button {
            display: inline-block;
            color: ${colors.white};
            background: ${colors.orange.default};
            padding: 10px;
            border-radius: 4px;
            border: none;
        }

        & label {
            font-size: 13px;
            display: block;
            padding: 6px 0;
        }

        & .video {
            margin: 10px 0;
            padding-bottom: 10px;
            background: ${colors.white};
            border: solid 1px ${colors.offWhite};
            border-radius: 4px;
        }

        & .video label,
        & .video input {
            text-align: left;
        }
    }

    & .rw-placeholder {
        color: #9faab2;
    }

    & .rw-list-option.rw-state-selected,
    & .rw-list-option.rw-state-selected:hover {
        background-color: ${colors.orange.default};
        border: ${colors.orange.default} 1px solid;
        color: white;
    }

    & .rw-widget-input.rw-state-focus,
    & .rw-state-focus > .rw-widget-container,
    & .rw-state-focus > .rw-widget-container:hover {
        border: ${colors.orange.default} 1px solid;
        box-shadow: 0 0 8px rgba(231, 100, 36, .4);
    }

    & .rw-list-option.rw-state-focus,
    & .rw-list-option.rw-state-focus:hover {
        border: ${colors.orange.default} 1px solid;
    }

    div.col div.half-width div {
        max-width: 50%;
    }
`;

export default StyledForm;



// WEBPACK FOOTER //
// ./src/components/shared/StyledForm.js